define('utils/dom', [], function () {
  'use strict';

  function hasClass(el, className) {
    var reg = new RegExp('(^|\\s)' + className + '(\\s|$)');
    return reg.test(el.className);
  }

  function addClass(el, className) {
    if (hasClass(el, className)) {
      return
    }

    var newClass = el.className.split(' ')
    newClass.push(className)
    el.className = newClass.join(' ')
  } 

  function removeClass(el, className) {
    if (!hasClass(el, className)) {
      return
    } 

    var reg = new RegExp('(^|\\s)' + className + '(\\s|$)', 'g')
    el.className = el.className.replace(reg, ' ')
  } 

  function getData(el, name, val) {
    var prefix = 'data-'
    if (val) {
      return el.setAttribute(prefix + name, val)
    }
    return el.getAttribute(prefix + name)
  }

  function getRect(el, force) {
    if (el instanceof window.SVGElement || force) {
      var rect = el.getBoundingClientRect()
      return {
        top: rect.top,
        left: rect.left,
        width: rect.width,
        height: rect.height
      }
    } else {
      return {
        top: el.offsetTop,
        left: el.offsetLeft,
        width: el.offsetWidth,
        height: el.offsetHeight
      }
    }
  }

  function getElmsWidth(els) {
    var width = 0;
    var len = els.length
    var el

    while (len--) {
      el = els[len]
      width += getRect(el).width
    }

    return width
  }

  function setStyle(target, src) {
    for (var key in src) {
      target.style[key] = src[key]
    }
  }

  var renderList = function (length, container, outer, inner) {
    var len = length

    var outerParse = outer.split('^')
    var innerParse = inner.split('^')

    var domFragment = document.createDocumentFragment()
    var outerTag = document.createElement(outerParse[0])
    var innerTag
    var temp = []

    outerTag.className = outerParse[1]

    for (var i = 0; i < len; i++) {
      innerTag = document.createElement(innerParse[0])
      innerTag.className = innerParse[1]
      innerTag._pointIndex = i
      outerTag.appendChild(innerTag)
      temp.push(innerTag)
    }

    domFragment.appendChild(outerTag)
    container.appendChild(domFragment)

    return temp;
  }

  var findParent = function (el, attrName, limitELm) {
    var attr

    while (el && el !== limitELm) {
      attr = el.getAttribute(attrName)

      if (attr) {
        return {
          el: el,
          attr: attr
        }
      }

      el = el.parentNode
    }

    return false
  }

  var removeElsClass = function (els, className) {
    var i = els.length;
    while (i--) {
      removeClass(els[i], className)
    }
  };

  return {
    getRect: getRect,
    getData: getData,
    removeClass: removeClass,
    addClass: addClass,
    hasClass: hasClass,
    getElmsWidth: getElmsWidth,
    setStyle: setStyle,
    renderList: renderList,
    findParent: findParent,
    removeElsClass: removeElsClass
  }
});
